(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["largest-selection-of-products-dynamic"] && !Shopify.designMode) return;
  try {
    
  // This script makes the entire card clickable, not just the link.
  // It is scoped to the section to run correctly.
  document.addEventListener('DOMContentLoaded', function() {
    const sectionId = 'shopify-section-{{ section.id }}';
    const sectionElement = document.getElementById(sectionId);

    if (sectionElement && !sectionElement.hasAttribute('data-mb-home-grid-js-loaded')) {
      sectionElement.setAttribute('data-mb-home-grid-js-loaded', 'true');

      const clickableCards = sectionElement.querySelectorAll('.js-clickable-card');

      clickableCards.forEach(card => {
        const link = card.querySelector('a');
        if (link) {
          card.classList.add('js-is-clickable');
          card.addEventListener('click', function(e) {
            // Ensure text selection doesn't trigger click
            if (window.getSelection().toString() === '') {
              // Navigate to the link's href
              window.location.href = link.href;
            }
          });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-policy"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordionHeaders = document.querySelectorAll(
      '#mb-shipping-info .mb-shipping__accordion-header'
    );

    if (!accordionHeaders.length) return;
    
    // Check if this script has already run for this section
    const section = accordionHeaders[0].closest('#mb-shipping-info');
    if (section.dataset.accordionLoaded) {
      return;
    }
    section.dataset.accordionLoaded = 'true';

    accordionHeaders.forEach((header) => {
      header.addEventListener('click', function () {
        const content = this.nextElementSibling;
        const isActive = this.classList.contains('active');

        // Close all other items
        accordionHeaders.forEach((otherHeader) => {
          if (otherHeader !== this) {
            otherHeader.classList.remove('active');
            otherHeader.nextElementSibling.style.maxHeight = null;
            otherHeader.nextElementSibling.style.paddingTop = '0';
            otherHeader.nextElementSibling.style.paddingBottom = '0';
          }
        });

        // Toggle current item
        if (isActive) {
          this.classList.remove('active');
          content.style.maxHeight = null;
          content.style.paddingTop = '0';
          content.style.paddingBottom = '0';
        } else {
          this.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.paddingTop = null; // Resets to CSS value
          content.style.paddingBottom = null; // Resets to CSS value
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
